import { render, staticRenderFns } from "./Cardbox.vue?vue&type=template&id=05030890&scoped=true&"
import script from "./Cardbox.vue?vue&type=script&lang=js&"
export * from "./Cardbox.vue?vue&type=script&lang=js&"
import style0 from "./Cardbox.vue?vue&type=style&index=0&id=05030890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05030890",
  null
  
)

export default component.exports